<template>
  <div :class="{'context-menu-item': true, 'context-menu-item-disabled': disabled}" @click="$emit('click')">
    <div class="context-menu-icon">
      <img v-if="iconSrc != null" :src="iconSrc"/>
    </div>
    <div class="context-menu-action">
      <span>{{ label }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['iconSrc', 'label', 'disabled'],
  }
</script>

<style scoped lang="scss">

  .context-menu-item {
    display: flex;
    align-items: center;
    padding: 8px 24px 8px 16px;
    line-height: 1.2;
    cursor: pointer;
    &.context-menu-item-disabled {
      opacity: 0.4;
      cursor: default;
      pointer-events: none;
    }
    &:first-child {
      padding-top: 8px;
    }
    &:last-child {
      padding-bottom: 8px;
    }
    &:hover {
      background-color: $gray-200;
    }
  }

  .context-menu-icon {
    width: 16px;
    margin-right: 12px;
    margin-top: -3px;
    fill: #313c5b;
    opacity: 0.6;
    img {
      width: 100%;
    }
  }

  .context-menu-action {
    font-size: 1rem;
    &.context-menu-action-default {
      font-weight: bold;
    }
  }

</style>
